import * as React from "react";
const SendUploadTipIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <path
      d="M19.1218 22.1504V29.628C19.1218 29.8964 19.213 30.1211 19.3954 30.302C19.5778 30.483 19.8043 30.5734 20.0749 30.5734C20.3455 30.5734 20.5694 30.483 20.7468 30.302C20.9241 30.1211 21.0128 29.8964 21.0128 29.628V22.1504L23.9712 25.1248C24.0331 25.1867 24.188 25.167 24.4359 25.0655C24.6837 24.964 24.9161 24.8737 25.133 24.7946C25.3499 24.7156 25.5032 24.6803 25.5929 24.6889C25.6827 24.6974 25.5865 24.8427 25.3045 25.1248C25.501 24.9282 25.5924 24.706 25.5785 24.4581C25.5646 24.2102 25.4647 23.988 25.2788 23.7915L20.8377 19.445C20.713 19.3191 20.5793 19.2284 20.4368 19.1729C20.2942 19.1173 20.1467 19.0895 19.9945 19.0895C19.8422 19.0895 19.6966 19.1173 19.5577 19.1729C19.4188 19.2284 19.287 19.3189 19.1623 19.4441L14.7628 23.8588C14.5769 24.0446 14.4813 24.2642 14.476 24.5174C14.4706 24.7706 14.5609 25.0009 14.7468 25.2084C14.9434 25.3834 15.1683 25.4709 15.4215 25.4709C15.6747 25.4709 15.8942 25.3779 16.0801 25.192L19.1218 22.1504ZM9.90392 35.8331C9.25034 35.8331 8.6863 35.5958 8.2118 35.1213C7.7373 34.6468 7.50005 34.0828 7.50005 33.4292V6.57038C7.50005 5.9168 7.7373 5.35276 8.2118 4.87826C8.6863 4.40376 9.25034 4.1665 9.90392 4.1665H23.391C23.726 4.1665 24.0422 4.23328 24.3394 4.36684C24.6366 4.50039 24.8964 4.67294 25.1186 4.88446L31.782 11.5479C31.9935 11.7701 32.1661 12.0298 32.2996 12.327C32.4332 12.6243 32.5 12.9404 32.5 13.2754V33.4292C32.5 34.0828 32.2627 34.6468 31.7882 35.1213C31.3137 35.5958 30.7497 35.8331 30.0961 35.8331H9.90392ZM23.4391 11.9325V6.05751H9.90392C9.7757 6.05751 9.65816 6.11092 9.5513 6.21776C9.44446 6.32462 9.39105 6.44216 9.39105 6.57038V33.4292C9.39105 33.5574 9.44446 33.675 9.5513 33.7818C9.65816 33.8887 9.7757 33.9421 9.90392 33.9421H30.0961C30.2243 33.9421 30.3419 33.8887 30.4487 33.7818C30.5555 33.675 30.609 33.5574 30.609 33.4292V13.1344H24.641C24.3083 13.1344 24.0248 13.0173 23.7905 12.783C23.5563 12.5488 23.4391 12.2653 23.4391 11.9325Z"
      fill="url(#paint0_linear_2040_1442)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2040_1442"
        x1={32.5}
        y1={7.9631}
        x2={2.79272}
        y2={14.5353}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#41B0F8" />
        <stop offset={0.505208} stopColor="#626DFD" />
        <stop offset={1} stopColor="#7232FB" />
      </linearGradient>
    </defs>
  </svg>
);
export default SendUploadTipIcon;
